import { useContext } from 'react';
import { NotifyContext } from './NotificationProvider';

// comicox____@2022

function useNotify() {
    return useContext(NotifyContext);
}

export default useNotify;
